"use client"

import { useState } from "react"
import { Github, Loader2 } from "lucide-react"
import { mulaiMasukSosial } from "@/modules/akun/actions/auth-actions"
import { PesanGalat } from "@/modules/akun/ui/kolom"
import type { PenyediaSosial } from "@/modules/akun/domain/tipe"

function IkonGoogle() {
  return (
    <svg viewBox="0 0 24 24" className="h-5 w-5" aria-hidden="true">
      <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.27-4.74 3.27-8.1z" />
      <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23z" />
      <path fill="#FBBC05" d="M5.84 14.1a6.6 6.6 0 0 1 0-4.2V7.06H2.18a11 11 0 0 0 0 9.88l3.66-2.84z" />
      <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1A11 11 0 0 0 2.18 7.06l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z" />
    </svg>
  )
}

export function TombolSosial({ penyedia, lanjut = null }: { penyedia: PenyediaSosial; lanjut?: string | null }) {
  const [memproses, setMemproses] = useState<"google" | "github" | null>(null)
  const [galat, setGalat] = useState<string | null>(null)

  if (!penyedia.google && !penyedia.github) return null

  const mulai = async (nama: "google" | "github") => {
    setGalat(null)
    setMemproses(nama)
    const hasil = await mulaiMasukSosial(nama, lanjut)
    if (!hasil.ok) {
      setMemproses(null)
      setGalat(hasil.pesan)
      return
    }
    window.location.assign(hasil.data.url)
  }

  const kelasTombol =
    "inline-flex h-12 flex-1 items-center justify-center gap-2.5 rounded-full border border-border bg-secondary/60 text-sm font-semibold text-foreground transition-colors hover:bg-secondary disabled:pointer-events-none disabled:opacity-60 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"

  return (
    <div className="space-y-3">
      <div className="flex gap-3">
        {penyedia.google && (
          <button type="button" onClick={() => mulai("google")} disabled={memproses !== null} className={kelasTombol}>
            {memproses === "google" ? <Loader2 className="h-4 w-4 animate-spin" /> : <IkonGoogle />}
            Google
          </button>
        )}
        {penyedia.github && (
          <button type="button" onClick={() => mulai("github")} disabled={memproses !== null} className={kelasTombol}>
            {memproses === "github" ? <Loader2 className="h-4 w-4 animate-spin" /> : <Github className="h-5 w-5" />}
            GitHub
          </button>
        )}
      </div>
      <PesanGalat pesan={galat} />
    </div>
  )
}
